// test1084
(1084 && 0);
